import {resolveCity,cityById} from './regionalCities';
import markets from '../data/markets.json';
export { markets };
export const MARKET_EVENT = 'loop-market-changed';
const key = 'loop-search-market-v1';
export function getMarket(code) { return markets.find(m => m.code === String(code || '').toUpperCase()) || markets[0]; }
export function deviceMarket(zone) {
  try {
    const timezone = zone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    return markets.find(m => m.zones.includes(timezone)) || null;
  } catch { return null; }
}
export function savedSearchMarket() {
  try {
    const code = JSON.parse(localStorage.getItem(key) || '{}').countryCode;
    return markets.find(m => m.code === code) || null;
  } catch { return null; }
}
export function readSearchMarket() { return savedSearchMarket() || deviceMarket() || markets[0]; }
export function saveSearchMarket(countryCode, city = '', cityId = null) {
  const market = getMarket(countryCode);
  localStorage.setItem(key, JSON.stringify({countryCode:market.code,city: String(city || "").trim().slice(0,100),cityId:cityById(market.code,cityId)?.id || resolveCity(market.code,city)?.id || null}));
  localStorage.removeItem('loop_user_location_pa_v1');
  // A previous Panama neighbourhood must not narrow a different country's search.
  window.dispatchEvent(new CustomEvent(MARKET_EVENT, {detail:market.code}));
  return market;
}
export function businessCountry(business = {}) {
  // Compatibility for historical Panama businesses, pending an audited backfill.
  return String(business.countryCode || business.marketCountry || 'PA').toUpperCase();
}
export function readSearchCity() {
  try { return String(JSON.parse(localStorage.getItem(key) || '{}').city || '').trim().slice(0,100); } catch { return ''; }
}
export function readSearchCityId(){try{return cityById(readSearchMarket().code,JSON.parse(localStorage.getItem(key)||'{}').cityId)?.id || null;}catch{return null;}}
export const normalizeCity = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
export function matchesMarket(business, code = readSearchMarket().code) {
  if (businessCountry(business) !== code) return false;
  const city = readSearchCity();
  if (!city || code !== readSearchMarket().code) return true;
  const selectedId=readSearchCityId();
  if(selectedId && business.cityId)return business.cityId===selectedId;
  return [business.city, business.location?.city, business.address?.city].some(value => typeof value === 'string' && (selectedId ? resolveCity(code,value)?.id === selectedId : (resolveCity(code,value)?.id || normalizeCity(value)) === (resolveCity(code,city)?.id || normalizeCity(city))));
}
export function marketCacheKey() { return readSearchMarket().code + ':' + (readSearchCityId() || normalizeCity(readSearchCity())); }

export function formatMarketMoney(amount, currency = 'USD', locale = 'es-PA') {
  return new Intl.NumberFormat(locale, {style:'currency',currency,currencyDisplay:'code'}).format(Number(amount) || 0);
}
